import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalNotificationProto } from '../proto/generated/global-notification'
import { AlertsStateType, AlertsTabType } from './alerts.reducer'

export enum GlobalNotificationTab {
    SYSTEM_NOTIFICATION = 'system',
    PRODUCT_ANNOUNCEMENT = 'updates'
}

export interface GlobalNotificationsState {
    notifications: GlobalNotificationProto[]
    newNotifcations: GlobalNotificationProto[]
    dismissedNotifications: string[]
    globalNotificationTab: GlobalNotificationTab
}

export const golbalNotificationInitialState: GlobalNotificationsState = {
    notifications: [],
    newNotifcations: [],
    dismissedNotifications: [],
    globalNotificationTab: GlobalNotificationTab.SYSTEM_NOTIFICATION
}

const globalNotificationsSlice = createSlice({
    name: 'globalNotifications',
    initialState: golbalNotificationInitialState,
    reducers: {
        addNotifications: (state, action: PayloadAction<GlobalNotificationProto[]>) => {
            const activeNotifs = action.payload.filter((notification) => notification.active)
            const deactivatedIds = new Set(action.payload.filter((n) => !n.active).map((n) => n.id))
            const dismissedIds = state.dismissedNotifications
            const existingIds = new Set(state.notifications.map((n) => n.id))
            const mergedNotifications = state.notifications.filter((n) => n.active)
            activeNotifs.forEach((notif) => {
                if (!existingIds.has(notif.id)) {
                    mergedNotifications.push(notif)
                    existingIds.add(notif.id)
                }
            })
            state.notifications = mergedNotifications.filter((n) => !deactivatedIds.has(n.id))
            state.newNotifcations = mergedNotifications.filter((n) => !dismissedIds.includes(n.id) && !deactivatedIds.has(n.id))
        },

        dismissNotification: (state, action: PayloadAction<string[]>) => {
            const dismissedNotificationsSet = new Set(state.dismissedNotifications)
            action.payload.forEach((id) => dismissedNotificationsSet.add(id))
            state.dismissedNotifications = Array.from(dismissedNotificationsSet).filter((id) => state.notifications.some((n) => n.id === id))
            state.newNotifcations = state.notifications.filter((n) => !dismissedNotificationsSet.has(n.id))
        },

        setGlobalNotificationTab(state, action: PayloadAction<GlobalNotificationTab>){
            return {
                ...state,
                globalNotificationTab: action.payload
            }
        }
    }
})

export const { addNotifications, dismissNotification, setGlobalNotificationTab } = globalNotificationsSlice.actions
export default globalNotificationsSlice.reducer
